import Loadable from 'react-loadable';

import LoadingModal from 'modals/LoadingModal';

export const LoginModalContainerLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "LoginModalContainer" */
      './LoginModalContainer.dynamic'
    ),
  loading: LoadingModal,
});
